import PropTypes from 'prop-types'
import Select from '../../../Nodes/Select'

const select = (props) => {
    const className = 'grid__cell--' + (props.span || '12')

    return (
        <div className={className}>
            <Select 
                label={props.name}
                required={props.required}
                options={props.options}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onInput} />
        </div>
    )
}

select.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    options: PropTypes.array.isRequired,
    span: PropTypes.string,
    title: PropTypes.string,
    placeholder: PropTypes.string
}

export default select